import React from "react";
import ReactDOM from "react-dom";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./index.css";
import App from "./App";

const AZURE_REDIRECT_URIS = {
  development: "http://localhost:3000/azure",
  staging: "https://staging-admin.spareboxstorage.com/azure",
  production: "https://admin.spareboxstorage.com/azure",
};

// MSAL configuration
const configuration = {
  auth: {
    clientId: "6eb7aad3-d27c-42ad-8e3c-4dd53ceadb27",
    redirectUri: AZURE_REDIRECT_URIS[process.env.REACT_APP_ENV],
    authority: "https://login.microsoftonline.com/e0606da8-6cee-44bc-9a69-9115a4be901e",
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

const pca = new PublicClientApplication(configuration);

// Global error handler to catch ReferenceError for missing variables
// This specifically handles the "Can't find variable: data" error in refreshToken
window.addEventListener("error", (event) => {
  if (
    event.error &&
    event.error.message &&
    event.error.message.includes("Can't find variable: data") &&
    event.error.stack &&
    event.error.stack.includes("refreshToken")
  ) {
    console.warn("Caught refreshToken error - this may be from cached/minified code:", event.error);
    // Prevent the error from propagating
    event.preventDefault();
    return true;
  }
});

// Also handle unhandled promise rejections
window.addEventListener("unhandledrejection", (event) => {
  if (
    event.reason &&
    event.reason.message &&
    event.reason.message.includes("Can't find variable: data") &&
    event.reason.stack &&
    event.reason.stack.includes("refreshToken")
  ) {
    console.warn("Caught refreshToken promise rejection:", event.reason);
    event.preventDefault();
  }
});

// Stub function to prevent errors if refreshToken is called from minified/cached code
// This handles cases where old cached code might try to call refreshToken
if (typeof window.refreshToken === "undefined") {
  window.refreshToken = function(data) {
    console.warn("refreshToken called but not implemented. Data:", data);
    // Return a rejected promise to prevent further errors
    return Promise.reject(new Error("Token refresh not implemented"));
  };
}

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={pca}>
      <ToastContainer
        position="top-left"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      ></ToastContainer>
      <App />
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
